module.exports = __webpack_public_path__ + "static/media/1023487.954146f1.png";